module.exports = __webpack_public_path__ + "static/img/8502_phase_function_Paper_Points.2e525e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/8502_phase_function_Paper_Points.png
// module id = b7pT
// module chunks = 0